import { Customer } from './customer';
import { Mill } from './mill';
import { OfferFamily } from './offer-family';
import { Material } from './material';
import { AuctionOfferStatus } from './auction-constants';

export class AuctionOffer {
	id = 0;
	name = '';
	mill: Mill | undefined;
	bundles: Bundle[] = [];
	market = '';
	startDate = '';
	endDate = '';
	year = 0;
	week = 0;
	plannedLoadingDate = '';
	paymentTerm = '';
	paymentTermCode = '';
	invoicingUnit = '';
	transportInvoicingCondition = '';
	status: AuctionOfferStatus = AuctionOfferStatus.PENDING;
	soldTos: Customer[] = [];
	numberOfBundles = 0;
	weight = 0;
	families: OfferFamily[] = [];
	family = '';
}

export interface Bundle {
	id: number;
	name: string;
	market: string;
	mill: Mill;
	year: number;
	week: number;
	numberOfProducts: number;
	weight: number;
	bids: Bid[];
	auctionOffer: AuctionOffer;
	material: Material[];
}

export interface Bid {
	id: number;
	creationDate: string;
	creationuserId: number;
	creationUser: string;
	soldTo: Customer;
	shipTo: Customer;
	endUser: Customer;
	customerReference: string;
	transportMode: number;
	transportModeDescription: string;
	incoterm: string;
	incotermDescription: string;
	incoterm2: string;
	incoterm2Description: string;
	price: number;
	transportPrice: number;
	typeOfMaritimetransport: number;
	typeOfMaritimeTransportDescription: string;
	extraTypeOfMaritimeTransport: number;
	status: string;
	bundle: Bundle;
}

export type FieldOfBid = keyof Bid;

type KeyOfNested<T> = T extends object
	? `.${ keyof T & string }`
	: never;

export type FieldOfAuctionOffer = keyof AuctionOffer
	| `bundles${ KeyOfNested<Bundle> }`
	| `bundles${ KeyOfNested<Bundle> }${ KeyOfNested<Material> }`;

export const AUCTION_OFFER_FIELD: FieldOfAuctionOffer[] = [
	'id',
	'mill',
	'bundles',
	'bundles.mill',
	'bundles.material.material',
	'bundles.bids',
	'name',
	'startDate',
	'endDate',
	'family'
];
